import { isCookiesAccepted } from "../globals";
import { useBrowserState } from "rylak-common/src/hooks/useBrowserStateOld.jsx";

export default function useBrowserStorageStateWithCookieCheck(props) {
    return useBrowserState({
        ...props,
        isCookiesAcceptedFn: () => isCookiesAccepted({ isInIframe: props.isInIframe }),
    });
}
